import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle, XCircle } from 'lucide-react';
export function WhoIsFor() {
  const forWho = ["Trabajadores independientes (Uber, Lyft, construcción, limpieza) cansados de las tarifas 'Premium'.", 'Empleados con W2 que quieren su reembolso rápido y sin pagar comisiones.', 'Personas con ITIN que quieren declarar sus impuestos de forma segura y económica.'];
  const notForWho = ['Multimillonarios con estructuras corporativas internacionales complejas.', 'Personas que disfrutan regalar $200 por una cita de 20 minutos.'];
  return <section className="bg-navy-light py-20 md:py-28 text-white" data-id="element-181">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-182">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12" data-id="element-183">
          {/* Who is it for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-dark p-8 md:p-10 rounded-2xl border border-green-500/30" data-id="element-184">
            <h2 className="text-3xl font-bold uppercase mb-8 text-white flex items-center" data-id="element-185">
              <CheckCircle className="w-8 h-8 text-green-400 mr-3" data-id="element-186" />
              Para quién es esto
            </h2>
            <ul className="space-y-6" data-id="element-187">
              {forWho.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-188">
                  <div className="w-2 h-2 mt-2.5 rounded-full bg-green-400 mr-4 flex-shrink-0" data-id="element-189"></div>
                  <p className="text-lg font-body text-gray-300" data-id="element-190">{item}</p>
                </li>)}
            </ul>
          </motion.div>

          {/* Who is it NOT for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-navy-dark p-8 md:p-10 rounded-2xl border border-red-500/30" data-id="element-191">
            <h2 className="text-3xl font-bold uppercase mb-8 text-white flex items-center" data-id="element-192">
              <XCircle className="w-8 h-8 text-red-400 mr-3" data-id="element-193" />
              Para quién NO es
            </h2>
            <ul className="space-y-6" data-id="element-194">
              {notForWho.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-195">
                  <div className="w-2 h-2 mt-2.5 rounded-full bg-red-400 mr-4 flex-shrink-0" data-id="element-196"></div>
                  <p className="text-lg font-body text-gray-300" data-id="element-197">{item}</p>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}